import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getProfileWorkFailed,
  getProfileWorkSuccess,
  getProfileWorkStart,
} from "../redux/getProfileWork";
import { getProfileWorkApi } from "core/http/service/operationProcess";

function* getWorkProfileWork() {
  try {
    const res = yield call(getProfileWorkApi);
    yield put({
      type: getProfileWorkSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getProfileWorkFailed.type,
    });
  }
}
function* watchGetWorkProfile() {
  yield takeLatest(getProfileWorkStart.type, getWorkProfileWork);
}

export default function* getWorkProfileSaga() {
  yield all([watchGetWorkProfile()]);
}
